import { useStyletron } from 'baseui';

export function Humidifier3D({active, height, width}: any) {
    const [css, theme] = useStyletron();
    const fillBackground = active ? theme.colors.accent300 : theme.colors.contentTertiary; //'#ADD8E6' : '#707070'
    const fillIcon = active ? theme.colors.accent : theme.colors.backgroundPrimary; //'#ADD8E6' : '#707070'
    const strokeIcon = active ? theme.colors.primary100 : theme.colors.contentTertiary; 

    return (
        <svg width={width || '100%'} height={height || '100%'} viewBox="0 0 100 100">
            <path id="heater_frameTop" d="M 60,0 L30,30 L50,30 L80,0" fill="#C0C0C0"></path>
            <path id="heater_frameFront" d="M 30,30 L30,100 L50,100 L50,30" fill="#A0A0A0"></path>
            <path id="heater_frameFace" d="M 80,0 L50,30 L50,100 L80,70" fill={theme.colors.primary400}></path>
            <path id="heater_backFace" d="M 75,12 L70,17 L70,67 L75,67" fill={theme.colors.primary300}></path>
            <path id="heater_bottom" d="M 75,67 L70,67 L55,82 L55,87" fill={theme.colors.primary200}></path>
            <path id="heater_grid" d="M 70,17 L55,32 L55,82 L70,67" fill={fillBackground}></path>

            <path id="heater_grill0" d="M 32,50 L38,50 L38,40 L48,40 L48,44 L42,44 L42,54 L32,54 Z" fill={fillBackground}></path>
            <path id="heater_grill1" d="M 32,68 L38,68 L38,58 L48,58 L48,62 L42,62 L42,72 L32,72 Z" fill={fillBackground}></path>
            <path id="heater_grill2" d="M 32,86 L38,86 L38,76 L48,76 L48,80 L42,80 L42,90 L32,90 Z" fill={fillBackground}></path>
            <svg id="heater_fire" x="43" y="32">
                <path transform="scale(0.5,0.5)" strokeWidth="3" d="M40,0 A50,50 0 0 1 60,50 A20,20 0 0 1 20,40 A15,17 0 0 1 25,31 A50,45 0 0 0 40,0" fill={fillIcon} stroke={strokeIcon}></path>
            </svg>
            <svg id="heater_fireCore" x="55" y="49">
                <path transform="scale(0.2,0.2)" d="M40,0 A50,50 0 0 1 60,50 A20,20 0 0 1 20,40 A15,17 0 0 1 25,31 A50,45 0 0 0 40,0" fill={fillIcon}></path>
            </svg>
        </svg>
    );
}